import React from 'react'
import Bus from '../../bus'

import { BETSLIP_STATE_UPDATE } from '../../actions'

import { BETSLIP_GROUP, RaceLogicMarkets } from '../../constants'
import { getBonusAssignedToBet } from '../../utils'

export const BetslipContext = React.createContext()

export function useBetslipState () {
  return React.useContext(BetslipContext)
}

export function useBetslipDispatch () {
  const { id } = useBetslipState()

  return React.useCallback(
    action => Bus.emit(`betslip:${id}`, action),
    [id]
  )
}

export function useBetslipStateUpdate () {
  const { id } = useBetslipState()

  return React.useCallback(
    payload => Bus.emit(`betslip:${id}`, {
      type: BETSLIP_STATE_UPDATE,
      payload
    }),
    [id]
  )
}

/*
 * TODO: define and use BETSLIP_GROUP for singles and SRM bets
 */

export function getSingleBetItems () {
  const { betItems } = useBetslipState()

  return React.useMemo(() => betItems.filter(bet => bet.marketTypeId !== RaceLogicMarkets.SAME_RACE_MULTI &&
    bet.betSlipGroup !== BETSLIP_GROUP.SAME_GAME_MULTI), [betItems])
}

export function getSrmBetItems () {
  const { betItems } = useBetslipState()

  return React.useMemo(() => betItems.filter(bet => bet.marketTypeId === RaceLogicMarkets.SAME_RACE_MULTI &&
    bet.betSlipGroup !== BETSLIP_GROUP.SAME_GAME_MULTI), [betItems])
}

export function getSgmBetItems () {
  const { betItems } = useBetslipState()

  return React.useMemo(() => betItems.filter(bet => bet.betSlipGroup === BETSLIP_GROUP.SAME_GAME_MULTI), [betItems])
}

export function getBetNowItem () {
  const { betItems } = useBetslipState()

  return React.useMemo(() => betItems.find(bet => bet.betNow), [betItems])
}

export const getBonusAssignedToBetByRequestId = (requestId) => {
  const { bonusAssignments, bonuses } = useBetslipState()
  return React.useMemo(() => getBonusAssignedToBet({ requestId, bonusAssignments, bonuses }), [bonusAssignments, bonuses])
}
